module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: _vm.classes,
    attrs: {
      "type": _vm.htmlType,
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.loading) ? _c('Icon', {
    staticClass: "ivu-load-loop",
    attrs: {
      "type": "load-c"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon && !_vm.loading) ? _c('Icon', {
    attrs: {
      "type": _vm.icon
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSlot) ? _c('span', {
    ref: "slot"
  }, [_vm._t("default")], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d76be45a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--1-1!./node_modules/iview/src/components/button/button.vue
// module id = ueoP
// module chunks = 0